import React from 'react';
import moment from 'moment';

import { withTranslation } from 'providers/GILT.provider';

const USE_OLD_BOOK_TIME_OFF = false;

class MiniModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideMiniModal: this.props.miniModal,
      miniModalClicked: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps() {
    const { miniModal } = this.props;
    if (!miniModal) {
      this.setState({ hideMiniModal: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  // if clicked on outside of element
  handleClickOutside = () => {
    const { pickCurrentStylist } = this.props;
    const { miniModalClicked } = this.state;

    if (miniModalClicked) {
      return;
    }

    this.setState({ hideMiniModal: false });

    pickCurrentStylist(0, moment());

    const miniModalWrapEl = document.querySelector('.cal-entry-wrap.cal-state-bg-a.no-modal');

    if (miniModalWrapEl) {
      miniModalWrapEl.style.display = 'none';
    }

    // is visibility:hidden from scheduler.css
    const miniModalWrapElDublicated = document.querySelector('.cal-entry-wrap.cal-state-bg-a.mini-modal');

    if (miniModalWrapElDublicated) {
      miniModalWrapElDublicated.style.display = 'none';
    }
  };

  closeMiniModalFunc = (hideWrapper) => {
    this.setState({ hideMiniModal: false });

    const miniModalWrapEl = document.querySelector('.cal-entry-wrap.cal-state-bg-a');

    if (miniModalWrapEl && hideWrapper) {
      miniModalWrapEl.style.display = 'none';
    }
  };

  createTimeoff = () => {
    const { currentTime, createTimeoff } = this.props;
    this.setState({ miniModalClicked: true });
    createTimeoff(currentTime);
    this.closeMiniModalFunc();
  };

  createNewTimeoff = () => {
    const { currentTime, createNewTimeoff } = this.props;
    this.setState({ miniModalClicked: true });
    createNewTimeoff(currentTime);
    this.closeMiniModalFunc();
  };

  createBooking = () => {
    const { currentTime, createBooking } = this.props;
    this.setState({ miniModalClicked: true });
    createBooking(currentTime);
    this.closeMiniModalFunc();
  };

  render() {
    const { t } = this.props;
    const { hideMiniModal } = this.state;
    return hideMiniModal ? (
      <div data-bem="MiniModal" className="mini-modal full-width">
        <button onClick={() => this.closeMiniModalFunc(true)} className="close" />
        {USE_OLD_BOOK_TIME_OFF && (
          <button data-bem="MiniModal__old-time-off" onClick={this.createTimeoff} className="btn-time-off">
            {t('scheduler.newEntryModal.newTimeOffButton')}
          </button>
        )}

        <button data-bem="MiniModal__new-time-off" onClick={this.createNewTimeoff} className="btn-time-off">
          {t('scheduler.newEntryModal.newTimeOffButton')}
        </button>

        <button data-bem="MiniModal__appointment" onClick={this.createBooking} className="btn-book">
          {t('scheduler.newEntryModal.newAppointmentButton')}
        </button>
      </div>
    ) : null;
  }
}

export default withTranslation()(MiniModal);
